import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectNameLabel: {
		id: 'project-details.label-for-project-name-field',
		defaultMessage: 'Name',
		description: '',
	},
	projectKeyLabel: {
		id: 'project-details.label-for-project-key-field',
		defaultMessage: 'Key',
		description: '',
	},
	projectUrlLabel: {
		id: 'project-details.label-for-project-url-field',
		defaultMessage: 'URL',
		description: '',
	},
	projectTypeLabel: {
		id: 'project-details.label-for-project-type-field',
		defaultMessage: 'Project type',
		description: '',
	},
	saveFormButtonLabel: {
		id: 'common.words.save',
		defaultMessage: 'Save',
		description: '',
	},
	projectCategoryTitle: {
		id: 'project-details.project-category-title',
		defaultMessage: 'Category',
		description: 'this appears with the title in the project category dropdown selector',
	},
	projectCategoryPlaceholder: {
		id: 'project-details.project-category-placeholder',
		defaultMessage: 'Choose a category',
		description: 'the placeholder text that appears in the project category dropdown',
	},
	tooShortProjectNameError: {
		id: 'project-details.too-short-project-name-error',
		defaultMessage: 'Give your project a name (longer than {minCharacters} characters).',
		description:
			'Error message that is shown when the project name is less than the minimum number of allowed characters',
	},
	tooLongProjectNameError: {
		id: 'project-details.too-long-project-name-error',
		defaultMessage: "Project name can't exceed {maxCharacters} characters.",
		description:
			'Error message that is shown when the project name exceeds the maximum number of allowed characters',
	},
	tooLongProjectNameUnknownLimitError: {
		id: 'project-details.too-long-project-name-unknown-limit-error',
		defaultMessage: 'Project name has too many characters.',
		description:
			'Error message that is shown when the project name exceeds the maximum number of allowed characters',
	},
	requiredProjectKeyError: {
		id: 'project-details.required-project-key-error',
		defaultMessage: 'You must specify a valid project key.',
		description: 'Error message that is shown when the project key is empty',
	},
	tooLongProjectKeyError: {
		id: 'project-details.too-long-project-key-error',
		defaultMessage: "Project key can't exceed {maxCharacters} characters.",
		description:
			'Error message that is shown when the project key exceeds the maximum number of allowed characters',
	},
	tooLongProjectUrlError: {
		id: 'project-details.too-long-project-url-error',
		defaultMessage: "URL can't exceed {maxCharacters} characters.",
		description:
			'Error message that is shown when the project url exceeds the maximum number of allowed characters',
	},
	tooLongProjectKeyUnknownLimitError: {
		id: 'project-details.too-long-project-key-unknown-limit-error',
		defaultMessage: 'Project key has too many characters.',
		description:
			'Error message that is shown when the project key exceeds the maximum number of allowed characters',
	},
	invalidPatternProjectKeyError: {
		id: 'project-details.invalid-pattern-project-key-error',
		defaultMessage:
			'Project keys must start with an uppercase letter, followed by one or more uppercase alphanumeric characters.',
		description: 'Error message that is shown when the project key does not match a valid pattern',
	},
	invalidPatternProjectUrl: {
		id: 'project-details.invalid-pattern-project-url-error',
		defaultMessage: 'URL must start with http:// or https://.',
		description: 'Error message that is shown when the project url does not match a valid pattern',
	},
	projectKeyChangeWarning: {
		id: 'project-details.project-key-change-warning',
		defaultMessage:
			'Changing the project key will re-index your project, and may break some external integrations. <a>Learn more about project keys</a>.',
		description: 'Warning message that is shown when the project key changes',
	},
	requiredFieldsLegend: {
		id: 'project-details.required-fields-legend',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Legend explainer for required fields asterisk.',
	},
});
